<script lang="ts">
  import { getBlogFilterUrl } from '../services/blog-data-services';
  import { blogActiveFilter } from '../store/blog_store';

  export let blogCategories: Array<any> = [];
</script>

<section class="blog-filter-section">
  {#each blogCategories as category}
    <a
      class="blog-filter-button"
      class:selected={category?.id === $blogActiveFilter}
      href={getBlogFilterUrl(category?.id)}
    >
      {category?.category}
    </a>
  {/each}
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .blog-filter-section {
    background: $neutral-light-04;
    padding: 55px 30px;
    display: flex;
    gap: 12px;
    overflow: scroll;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    @include desktop-max-width {
      padding: 27px 20px;
      justify-content: flex-start;
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .blog-filter-button {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $secondary-gray-02;
    color: $neutral-dark-01;
    border-radius: 100px;
    padding: 12px;
    gap: 12px;
    min-height: 42px;
    width: fit-content;
    cursor: pointer;
    white-space: nowrap;
  }
  .selected {
    background: $neutral-dark-01;
    color: $primary-white;
  }
</style>
